import { Suspense } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthLayout from '@/components/AuthLayout';
import publicRoutes from './publicRoutes';
import privateRoutes from './privateRoutes';

function AppRoutes() {
    const isAuthenticated = useSelector((state) => state.authentication.login.isAuthenticated);

    return (
        <Router>
            <Routes>
                {publicRoutes.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        element={<route.component />}
                    />
                ))}
                <Route
                    path="/app/*"
                    element={
                        isAuthenticated
                            ? (
                                <AuthLayout>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <Routes>
                                            {privateRoutes.map((route, index) => (
                                                <Route
                                                    key={index}
                                                    path={route.path}
                                                    exact={route.exact}
                                                    element={<route.component />}
                                                />
                                            ))}
                                        </Routes>
                                    </Suspense>
                                </AuthLayout>
                            ) : (
                                <Navigate
                                    to={{
                                        pathname: '/login',
                                    }}
                                />
                            )
                    }
                />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </Router>
    );
}

export default AppRoutes;
